import PaymentPlanStructure from './PaymentPlanStructure';

export default PaymentPlanStructure;
